import React, {useEffect, useRef, useState} from 'react';
import CameraLive from "../../camera/CameraLive";
import {colors} from "../../../maps/colors";
import styled from "styled-components";

const CameraWrapperStyled = styled.div`
    width: 100%;

    h3 {
        text-align: center;
        margin: 0;
    }
`;

const DrawContainerStyled = styled.div`
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
`;

const RoiCameraItem = ({camera, drawBoundingBox, box, title, onAddDot, onMoveDot}) => {
    const {streamFullRtspUrl, pt, z, rotate} = camera;

    const wrapperRef = useRef(null);
    const cameraRef = useRef(null);

    const [height, s_height] = useState(0);
    const [width, s_width] = useState(0);

    const [x, s_x] = useState(0);
    const [y, s_y] = useState(0);

    const [y_percent, s_y_percent] = useState(0);
    const [x_percent, s_x_percent] = useState(0);

    useEffect(() => {
        if (wrapperRef.current && wrapperRef.current.offsetWidth) {
            s_height(wrapperRef.current.offsetHeight);
            s_width(wrapperRef.current.offsetWidth);
        }
    }, [wrapperRef?.current]);


    const isPreview = false;

    let cursor = 'pointer';
    if (drawBoundingBox) {
        cursor = 'crosshair';
    }
    const mouseMove = e => {
        if (drawBoundingBox) {
            const pos = e.currentTarget.getBoundingClientRect();
            let current_x = parseInt(e.clientX - pos.left);
            let current_y = parseInt(e.clientY - pos.top);
            let current_x_percent = Number((x / width * 100).toFixed(2));
            let current_y_percent = Number((y / height * 100).toFixed(2));
            if (rotate === 90) {
                current_x_percent = Number(((y / width * 100)).toFixed(2));
                current_y_percent = Number(100 - ((x / height * 100)).toFixed(2));
            }

            if (rotate === 180) {
                current_x_percent = Number(100 - ((x / width * 100)).toFixed(2));
                current_y_percent = Number(100 - ((y / height * 100)).toFixed(2));
            }

            if (rotate === 270) {
                current_x_percent = Number(100 - ((y / width * 100)).toFixed(2));
                current_y_percent = Number(((x / height * 100)).toFixed(2));
            }

            s_x(current_x);
            s_y(current_y);
            s_x_percent(current_x_percent);
            s_y_percent(current_y_percent);

            onMoveDot({
                x: current_x,
                y: current_y,
                x_percent: current_x_percent,
                y_percent: current_y_percent
            });
        }
    };

    const mouseClick = () => {
        if (drawBoundingBox) {
            onAddDot({
                x,
                y,
                x_percent,
                y_percent
            });
        }
    };

    return (
        <CameraWrapperStyled
            ref={wrapperRef}
        >
            <h3>{title}</h3>
            <CameraLive disableControls={true} pt={pt} z={z}
                        camera={camera}
                        rotate={rotate}
                        rtspUrl={streamFullRtspUrl}
                        resolution={`480x270`}
            >
                <DrawContainerStyled
                    onMouseMove={mouseMove}
                    onClick={mouseClick}
                    ref={cameraRef}
                    style={{
                        cursor: cursor,
                        background: drawBoundingBox ? '#FFFFFF50' : 'none'
                    }}
                >
                    <svg
                        height="100%" width="100%"
                        style={{position: 'absolute', top: 0, left: 0}}>
                        <polygon points={
                            box.map(dot => {
                                return (
                                    `${dot.x_percent * width / 100},${dot.y_percent * height / 100}`
                                );
                            }).join(',')
                        } style={{
                            fill: !isPreview ? '#F8000050' : colors.LIGHT_GRAY_HALF_TRANS,
                            stroke: 'white',
                            strokeWidth: 2
                        }}/>
                    </svg>
                </DrawContainerStyled>
            </CameraLive>
        </CameraWrapperStyled>
    );
};

export default RoiCameraItem;